module.exports = __webpack_public_path__ + "static/sample-a368b30bc873691bbb1a402613708867.svg";